export default __webpack_public_path__ + "static/media/club-mahindra.c6f886b6.svg";